// Badge-Varianten des Workspace (Designkonzept 2026-08-13 §2/§5).
// bloom = Blau (Fachsignal), warn = Amber (Vagheit/Distanz 2), err = Rot
// (nur hohe Misalignment-Severity), orphan = gestrichelt grau (verwaist).
export type BadgeVariant = "plain" | "bloom" | "warn" | "err" | "orphan";

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  plain: "border-ws-surface-border text-ws-surface-muted bg-white/[0.03]",
  bloom: "text-ca-surface-accent border-[rgba(77,124,254,.35)]",
  warn: "text-verdict-amber border-[rgba(245,166,35,.4)] bg-[rgba(245,166,35,.07)]",
  err: "text-verdict-red border-[rgba(255,92,92,.4)] bg-[rgba(255,92,92,.07)]",
  orphan: "text-ws-surface-muted border-dashed border-ws-surface-border bg-transparent",
};

export default function WsBadge({
  variant = "plain",
  children,
}: {
  variant?: BadgeVariant;
  children: React.ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${VARIANT_CLASS[variant]}`}
    >
      {children}
    </span>
  );
}
